import { DateService } from '@rocheglobal/component-library-dot-com/src/services/date';
import React, { useEffect, useState } from 'react';
import { StoryTeaserService } from '../../services/story-teaser';
import { BlokToComponentProps, BaseBlok } from '../../helpers/blok-to-component/types';

type RochePublishedDateType = BlokToComponentProps<BaseBlok>;

export const RochePublishedDate = ({ blok, storyId, updateHoistedState }: RochePublishedDateType): JSX.Element => {
  const [state, setState] = useState<{ date: string | null }>({
    date: null,
  });

  useEffect(() => {
    if (!storyId) {
      return;
    }
    const { _uid: uid } = blok;
    if (!blok.preRenderContent) {
      StoryTeaserService.getStoryTeaser(storyId as number).then(async (result) => {
        const { first_published_at: publishedDate } = result;

        setState({
          ...state,
          date:
            publishedDate && typeof document !== 'undefined'
              ? await DateService.formatDate(publishedDate, 'dateFull')
              : null,
        });

        updateHoistedState?.(1, 1, uid, result);
      });
    } else {
      const { first_published_at: publishedDate } = blok.preRenderContent;
      DateService.formatDate(publishedDate, 'dateFull').then(async (result) => {
        setState({
          date: result,
        });
        updateHoistedState?.(1, 1, uid, result);
      });
    }
  }, []);

  return <roche-published-date published-date={state.date}></roche-published-date>;
};
